/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ApBusinessDocumentSettingResponse } from '../model/apBusinessDocumentSettingResponse';
import type { ApBusinessDocumentSettingUpdateRequest } from '../model/apBusinessDocumentSettingUpdateRequest';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Retrieve business document setting
 */
export const useGetApiJsApBusinessDocumentSettingHook = () => {
  const getApiJsApBusinessDocumentSetting =
    useCustomClient<ApBusinessDocumentSettingResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApiJsApBusinessDocumentSetting(
      { url: `/api/js/ap_business_document_setting`, method: 'GET', signal },
      options
    );
  };
};

export const getGetApiJsApBusinessDocumentSettingQueryKey = () => {
  return [`/api/js/ap_business_document_setting`] as const;
};

export const useGetApiJsApBusinessDocumentSettingQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiJsApBusinessDocumentSettingQueryKey();

  const getApiJsApBusinessDocumentSetting =
    useGetApiJsApBusinessDocumentSettingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
    >
  > = ({ signal }) => getApiJsApBusinessDocumentSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiJsApBusinessDocumentSettingQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
  >
>;
export type GetApiJsApBusinessDocumentSettingQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Retrieve business document setting
 */
export const useGetApiJsApBusinessDocumentSetting = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApiJsApBusinessDocumentSettingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApiJsApBusinessDocumentSettingSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiJsApBusinessDocumentSettingQueryKey();

  const getApiJsApBusinessDocumentSetting =
    useGetApiJsApBusinessDocumentSettingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
    >
  > = ({ signal }) => getApiJsApBusinessDocumentSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiJsApBusinessDocumentSettingSuspenseQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
  >
>;
export type GetApiJsApBusinessDocumentSettingSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Retrieve business document setting
 */
export const useGetApiJsApBusinessDocumentSettingSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApiJsApBusinessDocumentSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApiJsApBusinessDocumentSettingSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update business document setting
 */
export const usePutApiJsApBusinessDocumentSettingHook = () => {
  const putApiJsApBusinessDocumentSetting = useCustomClient<void>();

  return (
    apBusinessDocumentSettingUpdateRequest: BodyType<ApBusinessDocumentSettingUpdateRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return putApiJsApBusinessDocumentSetting(
      {
        url: `/api/js/ap_business_document_setting`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: apBusinessDocumentSettingUpdateRequest,
      },
      options
    );
  };
};

export const usePutApiJsApBusinessDocumentSettingMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePutApiJsApBusinessDocumentSettingHook>>
    >,
    TError,
    { data: BodyType<ApBusinessDocumentSettingUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePutApiJsApBusinessDocumentSettingHook>>
  >,
  TError,
  { data: BodyType<ApBusinessDocumentSettingUpdateRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const putApiJsApBusinessDocumentSetting =
    usePutApiJsApBusinessDocumentSettingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePutApiJsApBusinessDocumentSettingHook>>
    >,
    { data: BodyType<ApBusinessDocumentSettingUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return putApiJsApBusinessDocumentSetting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiJsApBusinessDocumentSettingMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePutApiJsApBusinessDocumentSettingHook>>
  >
>;
export type PutApiJsApBusinessDocumentSettingMutationBody =
  BodyType<ApBusinessDocumentSettingUpdateRequest>;
export type PutApiJsApBusinessDocumentSettingMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update business document setting
 */
export const usePutApiJsApBusinessDocumentSetting = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePutApiJsApBusinessDocumentSettingHook>>
    >,
    TError,
    { data: BodyType<ApBusinessDocumentSettingUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    usePutApiJsApBusinessDocumentSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
